import * as React from 'react';
import { UspGroupItem } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { DonationSummary } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { useCartStorage } from '../../hooks/use-cart-storage.js';
import { useCartSummaryActionSlots } from '../../slots/summary-slot/context.js';
import { DiscountDescriptionsContainer } from '../DiscountDescriptions/containers/DiscountDescriptionsContainer.js';
import { VoucherCodesLayout } from '../VoucherCodes/VoucherCodesLayout.js';
import { TotalsContainer } from '../Totals/containers/TotalsContainer.js';
import { NavigationContainer } from './components/navigation/NavigationContainer.js';
import { useCart } from '../../context/Cart/context.js';

const Footer = ({ hasSubscription , readOnly , summaryLabel , policyItems , unavailableLineItems , handleCheckoutNavigation , donationAmount  })=>{
    const [{ cartId  }] = useCartStorage();
    const { Slots: SummaryActionSlots  } = useCartSummaryActionSlots();
    const { locale , currency , getLabel , getFormattedLabel  } = useIntl();
    const { cart  } = useCart();
    var _totalPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer"
    }, policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container mobile-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__aside"
    }, /*#__PURE__*/ React.createElement(DiscountDescriptionsContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__main"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "cart-footer__heading",
        variant: "small"
    }, summaryLabel), !readOnly && SummaryActionSlots.FirstComponent && /*#__PURE__*/ React.createElement(SummaryActionSlots.FirstComponent, {
        cartId: cartId
    }), !readOnly ? SummaryActionSlots.SecondComponent ? /*#__PURE__*/ React.createElement(SummaryActionSlots.SecondComponent, {
        cartId: cartId
    }) : /*#__PURE__*/ React.createElement(VoucherCodesLayout, {
        cartId: cartId
    }) : null, /*#__PURE__*/ React.createElement(TotalsContainer, null), donationAmount && /*#__PURE__*/ React.createElement(DonationSummary, {
        label: getLabel('checkout.payment.donation.summary.title'),
        formattedDonationAmount: formatPrice({
            locale,
            value: donationAmount,
            currency,
            isCentAmount: true
        }),
        disclaimer: getFormattedLabel('checkout.payment.donation.summary.description', {
            labelData: {
                total: formatPrice({
                    locale,
                    value: ((_totalPrice = cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : 0) + donationAmount,
                    currency,
                    isCentAmount: true
                }),
                cartTotal: formatPrice({
                    locale,
                    value: cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
                    currency,
                    isCentAmount: true
                }),
                donationTotal: formatPrice({
                    locale,
                    value: donationAmount,
                    currency,
                    isCentAmount: true
                })
            }
        })
    })), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__navigation"
    }, /*#__PURE__*/ React.createElement(NavigationContainer, {
        handleCheckoutNavigation: handleCheckoutNavigation,
        hasSubscription: hasSubscription,
        unavailableLineItems: unavailableLineItems
    })), policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container desktop-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
